/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import { Grid, TextField } from '@coursera/cds-core';

import _t from 'i18n!nls/admin-v2';

const styles = {
  root: () => css`
    margin-right: var(--cds-spacing-100);
  `,
  search: () => css`
    margin-right: var(--cds-spacing-150);
    margin-top: var(--cds-spacing-50) 0;
  `,
};

export type Props = {
  onQueryChange: (query: string) => void;
  additionalStyles?: SerializedStyles;
  placeholderText?: string;
  query?: string;
};

const SearchBar = ({ onQueryChange, additionalStyles, placeholderText, query }: Props) => {
  const [timer, setTimer] = React.useState<NodeJS.Timeout | null>(null);
  const [inputValue, setInputValue] = React.useState(query || '');

  const handleSearch = (evt: React.SyntheticEvent & { target: EventTarget & { value: string } }) => {
    const { value } = evt.target;
    if (timer) {
      clearTimeout(timer);
    }
    setInputValue(value);
    setTimer(
      setTimeout(() => {
        onQueryChange(value);
      }, 300)
    );
  };

  return (
    <Grid css={[styles.root, additionalStyles]} item xs={2} xl={3} container alignItems="center" alignContent="center">
      <TextField
        fullWidth
        css={styles.search}
        label=""
        placeholder={placeholderText ?? _t('Search')}
        onChange={handleSearch}
        value={inputValue}
      />
    </Grid>
  );
};
export default SearchBar;
